<template>
  <b-card title="Ticketing Text">
    <b-toast
      v-model="showSnackbar"
      :variant="snackbarColor"
      :title="snackbarColor === 'success' ? 'Success' : 'Failed'"
      solid
    >
      {{ snackbarMessage }}
    </b-toast>
    
    <b-card-actions-container>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group>
            <label for="running-text">Running Text</label>
            <b-form-input
              id="running-text"
              v-model="runningText"
              placeholder="Enter running text"
              class="my-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="lastUpdated">
        <b-col cols="2">
          Last Updated
        </b-col>
        <b-col cols="10">
          {{ dates(lastUpdated) }}
        </b-col>
        <b-col cols="2">
          Last Updated By
        </b-col>
        <b-col cols="10">
          {{ lastUpdatedBy }}
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" class="mt-2">
          <b-button
            variant="primary"
            @click="save"
            class="me-2 my-1"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-card-actions-container>
  </b-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { dateFormat } from "@/utils/utils";
import axios from '@/axios';

export default {
  data() {
    return {
      runningText: '',
      showSnackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      lastUpdated: '',
      lastUpdatedBy: ''
    };
  },
  mounted() {
    this.refetchData();
  },
  methods: {
    dates(date) {
      return dateFormat(date);
    },
    refetchData(hideOverlay) {
      axios.get(`sales-and-purchase/queue-setting`).then((res) => {
        if (res.data.data === null) {
          this.runningText = 'No Data';
          this.showSnackbar = true;
          this.snackbarColor = 'error';
          this.snackbarMessage = 'No Data Found, Please Insert Data First';
        } else {
          this.runningText = res.data.data.runningText;
          this.lastUpdated = res.data.data.updatedAt;
          this.lastUpdatedBy = res.data.data.updatedBy;
          this.showSnackbar = true;
          this.snackbarColor = 'success';
          this.snackbarMessage = 'Data Refreshed Successfully';
        }
      }).catch((e) => {
        console.log(e);
        this.showSnackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Error fetching data';
      });
      if (hideOverlay) setTimeout(hideOverlay, 1000);
    },
    save() {
      const payload = {
        runningText: this.runningText
      };
      axios.put(`sales-and-purchase/queue-setting`, payload).then((res) => {
        this.showSnackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Data Saved Successfully';
        this.refetchData();
      }).catch((e) => {
        console.log(e);
        this.showSnackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Got Error While Saving Data';
      });
    }
  },
  created() {
    document.title = "Ticketing Text | RSP";
  }
};
</script>

<route lang="yaml">
meta:
  subject: Queue Setting
  requiresAuth: true
</route>
